import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useRoles() {
  const [roles, setRoles] = useState([]);
  const reload = useCallback(() => api.get("/roles").then((r) => setRoles(r.data || [])).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return [roles, reload];
}

export function roleLabel(roles, id) {
  if (id === "admin") return "Admin";
  return roles.find((r) => r.id === id)?.name || id;
}

export function canSeeTask(worker, reason) {
  const role = (worker?.role || "").toLowerCase();
  if (role === "admin") return true;
  const vr = reason?.visible_roles?.length ? reason.visible_roles : ["todos"];
  return vr.includes("todos") || vr.includes(role);
}

export function visibleRolesLabel(roles, vr) {
  if (!vr?.length || vr.includes("todos")) return "Todos";
  return vr.map((id) => roleLabel(roles, id)).join(", ");
}
